module.exports = __webpack_public_path__ + "static/media/codeColorSliders.40a0a7d2.jpg";